// extracted by mini-css-extract-plugin
export var card = "_mf-5";
export var cardSelected = "_mf-4";
export var image = "_mf-3";
export var modal = "_mf-0";
export var modalContent = "_mf-1";
export var table = "_mf-2";